import { render, staticRenderFns } from "./downstreamPayment.vue?vue&type=template&id=5c5fd9d2&scoped=true"
import script from "./downstreamPayment.vue?vue&type=script&lang=js"
export * from "./downstreamPayment.vue?vue&type=script&lang=js"
import style0 from "./downstreamPayment.vue?vue&type=style&index=0&id=5c5fd9d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5fd9d2",
  null
  
)

export default component.exports